import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import { queriesKeys } from '../queriesKeys'

export const useGetEarningsStats = () =>
  useQuery({
    queryFn: () => api.earnings.getEarningsStats(),
    queryKey: queriesKeys.earnings.getEarningsStats(),
  })
